import intersectionHelper from '../../../general/js/intersection-helper';
import BaseComponent from '../../../general/js/base-component';
import stylesFinally from '../../../general/js/style-observer'

export default class QuotesBorderComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        stylesFinally(() => {
            intersectionHelper.enterViewportOnce(this.element, this.animate.bind(this), {
                threshold: 0.5
            });
        })
        
        document.addEventListener('buyingSelling:switch', this.animate.bind(this));
    }

    animate() {
        let path = this.element.querySelector('path');
        let length = path.getTotalLength();

        // Clear any previous transition
        path.style.transition = path.style.WebkitTransition = 'none';

        // Set up the starting positions
        path.style.strokeDasharray = length + ' ' + length;
        path.style.strokeDashoffset = length;

        // Trigger a layout so styles are calculated & the browser
        // picks up the starting position before animating
        path.getBoundingClientRect();

        // Define our transition
        path.style.transition = path.style.WebkitTransition = 'stroke-dashoffset 2s ease-in-out 0.5s';
        // Initial animation
        path.style.strokeDashoffset = '0';
        path.style.stroke = "#fff";
    }
}



// WEBPACK FOOTER //
// ./app/components/quotes-carousel/js/quotes-border.component.js